import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import "./style.css";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

function DespesasCategoria({ dados = [] }) {
  const categorias = dados;
  const total = categorias.reduce(
    (acc, c) => acc + Number(c.total || 0),
    0
  );

  const cores = [
    "#f97316",
    "#ef4444",
    "#7e22ce",
    "#16a34a",
    "#3b82f6",
    "#eab308",
    "#06b6d4",
    "#f43f5e"
  ];

  const data = {
    labels: categorias.map(c => c.categoria),
    datasets: [
      {
        data: categorias.map(c => Number(c.total || 0)),
        backgroundColor: cores,
        borderWidth: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%",
    animation: {
      animateRotate: true,
      duration: 1000
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: function(context) {
            return context.raw.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL"
            });
          }
        }
      },
      datalabels: {
        display: false
      }
    }
  };

  const formatar = (v) =>
    v.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });

  return (
    <div className="despesa-categoria-container">
      
      <div className="grafico-wrapper">
        <Doughnut data={data} options={options} />
        <div className="grafico-total">
          <small>Total</small>
          <strong>{formatar(total)}</strong>
        </div>
      </div>

      <div className="lista-categorias">
        {categorias.map((c, i) => {
          const valor = Number(c.total || 0);
          const percentual =
            total > 0
              ? ((valor / total) * 100).toFixed(1)
              : 0;

          return (
            <div key={i} className="categoria-item">
              <div className="categoria-left">
                <span
                  className="categoria-cor"
                  style={{ backgroundColor: cores[i % cores.length] }}
                ></span>
                <span>{c.categoria}</span>
              </div>
              <div className="categoria-right">
                <strong>{formatar(valor)}</strong>
                <small>{percentual}%</small>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DespesasCategoria;